export default "__VITE_ASSET__C3S3NSwQ__"